export default {
    baseUrl: "https://api.veohmo.ng"
};